import React from "react"
import { isEmpty, get } from "lodash"
//import { isEmptyObject } from "jquery";

import ImageModule from "./image_module";
import NoImage from "../images/no-image.png"
import { transform } from "lodash";

const ImageCallBack = ({imageSrc, processedImages, renderer, strapi_id, imagename, altText, classNames, ggfx_results}) => {
  let processRes = JSON.parse(processedImages);
  let ggfx_env = process.env.GATSBY_STRAPI_GGFX_ENV
  let image_url = imageSrc?.url
  let getSrcUrl = image_url?.substring(image_url?.indexOf(ggfx_env))
  // let checkGGFXImg = ggfx_results?.[getSrcUrl]?.["webp"]?.["376x250"];
  const checkGGFXImg  = ggfx_results && Array.isArray(ggfx_results)
  ? get(
      ggfx_results.find(ggfxRes => ggfxRes?.src_cftle === getSrcUrl),
      'transforms',
      []
    )?.find(res => res?.format === 'webp' && res?.transform === '376x250')?.url
  : undefined;

  //console.log("checkGGFXImg ==>", checkGGFXImg)

  if(isEmpty(imageSrc)){
    return <img src={NoImage} alt={altText} className={classNames}/>
  }

  return (
    !isEmpty(checkGGFXImg) ? 
      <ImageModule
        ImageSrc={imageSrc}
        altText={altText}
        imagetransforms={processedImages}
        renderer={renderer} // pic-src, srcSet, bgimg
        imagename={imagename}
        strapi_id={strapi_id}
        classNames={classNames}
        ggfx_results={ggfx_results}
      />
    :
      <img src={imageSrc?.url || imageSrc?.srcUrl}  classNames={classNames} alt={altText} />
  )
}

export default ImageCallBack